import { useEffect, useState } from "react";
import { ScrollProps } from "../../components/AdvancedSearch";
import { Header } from "../../components/Header";
import { Container, FormWrapper, FormGroup, Label, Input, TextArea, Select, RadioGroup, RadioOption, SubmitButton, BackButton, ButtonWrapper, FormRow } from './styles';
import { toast } from 'react-toastify';
import { useAuth } from "../../context/auth";
import { IoChevronBackOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { maskPhone2 } from "../../utils/mask";
import { Footer } from "../../components/Footer";

export function Ouvidoria() {

    const { api } = useAuth()
    const navigate = useNavigate();
    const location = useLocation();
    const motivoPrefill = (location.state as { motivo?: string } | null)?.motivo;

    const [scrollTop, setScrollTop] = useState<ScrollProps>({ y: 0, lastY: 0 } as ScrollProps);
    const [show, setShow] = useState(false);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        celular: '',
        assunto: '',
        identificacao: '',
        manifestacao: '',
        perfil: ''
    });

    useEffect(() => {
        if (motivoPrefill) {
            setFormData((prev) => ({
                ...prev,
                manifestacao: motivoPrefill,
                assunto: prev.assunto || 'Reclamação',
            }));
        }
    }, [motivoPrefill]);


    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        const scrollTop = event.currentTarget.scrollTop;
        setScrollTop(prevState => { return { y: scrollTop, lastY: prevState.y } })
    }

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;

        const cleanedValue = name === 'celular'
            ? value.replace(/\D/g, '')
            : value;

        setFormData(prev => ({ ...prev, [name]: cleanedValue }));
    };


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        await api.post('/portal/ouvidoria', formData).then(res => {
            toast.success('Sua mensagem foi enviada com sucesso', {
                position: "top-right",
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored'
            })
            setLoading(false);
            setFormData({
                nome: '',
                email: '',
                celular: '',
                assunto: '',
                identificacao: '',
                manifestacao: '',
                perfil: ''
            });
        }).catch(err => {
            toast.error(err.response.data.message || 'Ocorreu um erro ao enviar sua mensagem', {
                position: "top-right",
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored'
            })
            setLoading(false);
        })
    };

    const backToTheHome = () => {
        navigate('/');
    }

    return (
        <>
            <Container onScroll={handleScroll}>
                <Header scroll={scrollTop} show={show} setShow={setShow} search={search} setSearch={setSearch} />
                <div className="content_wrapper">
                    <BackButton onClick={backToTheHome}>
                        <IoChevronBackOutline className="icon" />
                        Voltar
                    </BackButton>
                    <h1>Formulário de Ouvidoria</h1>
                    <FormWrapper onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label>Nome completo<span style={{ color: 'red' }}>*</span></Label>
                            <Input name="nome" value={formData.nome} onChange={handleChange} required />
                        </FormGroup>

                        <FormRow>
                            <FormGroup style={{ flex: 1, marginRight: '1rem' }}>
                                <Label>Email<span style={{ color: 'red' }}>*</span></Label>
                                <Input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </FormGroup>

                            <FormGroup style={{ flex: 1 }}>
                                <Label>Celular</Label>
                                <Input
                                    type="tel"
                                    name="celular"
                                    value={maskPhone2(formData.celular)}
                                    maxLength={15}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </FormRow>


                        <FormGroup>
                            <Label>Assunto<span style={{ color: 'red' }}>*</span></Label>
                            <Select name="assunto" value={formData.assunto} onChange={handleChange} required>
                                <option value="">Selecione</option>
                                <option value="Elogio">Elogio</option>
                                <option value="Sugestão">Sugestão</option>
                                <option value="Reclamação">Reclamação</option>
                                <option value="Denúncia">Denúncia</option>
                                <option value="Solicitação">Solicitação</option>
                            </Select>
                        </FormGroup>

                        <FormGroup>
                            <Label>Identificação<span style={{ color: 'red' }}>*</span></Label>
                            <RadioGroup>
                                {['Sim', 'Sigilo', 'Anonimato'].map(option => (
                                    <RadioOption key={option}>
                                        <input
                                            type="radio"
                                            name="identificacao"
                                            value={option}
                                            checked={formData.identificacao === option}
                                            onChange={handleChange}
                                            required
                                        />
                                        <span>{option}</span>
                                    </RadioOption>
                                ))}
                            </RadioGroup>
                        </FormGroup>

                        <FormGroup>
                            <Label>Manifestação<span style={{ color: 'red' }}>*</span></Label>
                            <TextArea name="manifestacao" value={formData.manifestacao} onChange={handleChange} required />
                        </FormGroup>

                        <FormGroup>
                            <Label>Informe se é:<span style={{ color: 'red' }}>*</span></Label>
                            <Select name="perfil" value={formData.perfil} onChange={handleChange} required>
                                <option value="">Selecione</option>
                                <option value="Corretor">Corretor</option>
                                <option value="Cliente">Cliente</option>
                                <option value="Funcionário">Funcionário</option>
                                <option value="Outro">Outro</option>
                            </Select>
                        </FormGroup>

                        <ButtonWrapper>
                            <SubmitButton disabled={loading} type="submit">Enviar</SubmitButton>
                            <p style={{ fontSize: "0.9rem", textAlign: "right" }}>Ao enviar, você concorda com nossa <a href="/politica-de-privacidade" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>.</p>
                        </ButtonWrapper>
                    </FormWrapper>
                </div>
            </Container>
        <Footer />
        </>
    );
} 